module.exports = __webpack_public_path__ + "assets/img/success.2cb971f5.svg";